import { action, onConnect } from '@reatom/framework'

import { Array, Result } from '@blade/std-lib'
import { FollowerDetail } from '@root/entities/follower-detail'
import { selectedNetworkAtom } from '@root/entities/network'
import * as Network from '@root/entities/network/model/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { type Error } from '@root/shared'
import { ApiError, apiRequest } from '@root/shared/api'
import { reatomRequest } from '@root/shared/lib'

import type { DelugeId } from '@root/entities/user-short'

export const fetchRecommendationsRequestAction = action(
  async (
    ctx,
    { delugeId, network }: { delugeId: DelugeId; network: Network.Network },
  ): Promise<
    Result.Result<
      ReadonlyArray<FollowerDetail.FollowerDetail>,
      Error.UnknownError
    >
  > => {
    const {
      tradeApiClient,
      environment: { assets },
    } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.activityRecommendationsList, [
        {
          delugeId,
          network: Network.toDto(network),
        },
      ]),
    )

    return result.pipe(
      Result.map(
        Array.map((x) => FollowerDetail.fromDto(x, assets.avatarsHost)),
      ),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'fetchRecommendationsRequestAction',
)

export const recommendationsModel = ({ delugeId }: { delugeId: DelugeId }) => {
  const recommendationsStateAtom = reatomRequest({
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'filterItemsState',
    execAction: fetchRecommendationsRequestAction,
    prepare: (ctx) => ({ delugeId, network: ctx.get(selectedNetworkAtom) }),
  })

  onConnect(recommendationsStateAtom, (ctx) => {
    recommendationsStateAtom.execute(ctx)
  })

  return { recommendationsStateAtom }
}
